import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AllSpecialitiesApi } from 'src/app/_services/allSpecialities.service';

@Component({
  selector: 'app-speciality-report',
  templateUrl: './speciality-report.component.html',
  styleUrls: ['./speciality-report.component.scss']
})
export class SpecialityReportComponent implements OnInit {
  pageTitle: string = 'All Reports';
  dateRangeFrom: string;
  dateRangeTo: string;
  reports: [] = [];
  filteredReports: [] = [];

  constructor(
    private route: ActivatedRoute,
    private allSpecialitiesApi: AllSpecialitiesApi
  ) { }

  ngOnInit(): void {
    this.dateRangeFrom = this.route.snapshot.queryParams.FromDate;
    this.dateRangeTo = this.route.snapshot.queryParams.ToDate;

    this.getSpecialityReport(this.dateRangeFrom, this.dateRangeTo);
  }

  getSpecialityReport(dateRangeFrom, dateRangeTo) {
    this.allSpecialitiesApi.getSpecialityReport(dateRangeFrom, dateRangeTo).subscribe((response) => {

    })
  }
}
